"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, Drawer, useMediaQuery, useTheme } from "@mui/material";
import { colorSurfaceSurfaceVar } from "@/app/(styles)/variables";

// Desktop (md+): a centered floating panel with spacing on every side (MUI
// Dialog). Mobile/small screens: a full-page sheet sliding in from the right
// (MUI Drawer), matching the rest of the app's sidesheet pattern. This is
// used only by the enquiry-flow sheets (mandatory form / survey / review)
// per the updated design — the shared SideSheet primitive used elsewhere in
// the app is intentionally left untouched.
export default function EnquirySheetShell(t0) {
  const $ = _c(16);
  const {
    open,
    onClose,
    width: t1,
    children
  } = t0;
  const width = t1 === undefined ? 480 : t1;
  const theme = useTheme();
  let t2;
  if ($[0] !== theme.breakpoints) {
    t2 = theme.breakpoints.up("md");
    $[0] = theme.breakpoints;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isDesktop = useMediaQuery(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "&::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const scrollbarHidden = t3;
  if (isDesktop) {
    let t4;
    if ($[3] !== width) {
      t4 = {
        paper: {
          sx: {
            width,
            maxWidth: width,
            height: "calc(100vh - 96px)",
            maxHeight: "calc(100vh - 96px)",
            margin: 0,
            borderRadius: "16px",
            backgroundColor: colorSurfaceSurfaceVar,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            ...scrollbarHidden
          }
        }
      };
      $[3] = width;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== children || $[6] !== onClose || $[7] !== open || $[8] !== t4) {
      t5 = <Dialog open={open} onClose={onClose} maxWidth={false} slotProps={t4}>{children}</Dialog>;
      $[5] = children;
      $[6] = onClose;
      $[7] = open;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keepMounted: false
    };
    t5 = {
      "& .MuiDrawer-paper": {
        width: "100%",
        backgroundColor: colorSurfaceSurfaceVar,
        ...scrollbarHidden
      }
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== children || $[13] !== onClose || $[14] !== open) {
    t6 = <Drawer anchor="right" variant="temporary" open={open} onClose={onClose} ModalProps={t4} sx={t5}>{children}</Drawer>;
    $[12] = children;
    $[13] = onClose;
    $[14] = open;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}